var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-card-text',_vm._l((_vm.recordQuestionSummaryAdditionalData.questions),function(question,questionIndex){return _c('RecordQuestionSummaryRegularItem',{key:questionIndex,attrs:{"record-question-summary-regular-item-data":question}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }